'use client';
import { MdCancel } from "react-icons/md";
import { ProjectAccessLogic } from "./ProjectAccessLogic";
import "./ProjectAccessModal.css";
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { useState } from "react";
const ProjectAccessModal = ({ user, onClose, datasets = [], usersList }) => {
  const {
    showPassword,
    setShowPassword,
    userState,
    empInfo,
    setUserState,
    errors,
    setErrors,
    isAdmin,
    toggleDataset,
    toggleIfAdmin,
    handleChange,
    handleSave,
    selectAllDatasets,
    deselectAllDatasets,
    ACCESS_LEVEL,
    normalizeAccessLevel,
    loadProjectAccess,
    isEditMode,
    isAnythingChanged
  } = ProjectAccessLogic({ user, onClose, datasets, usersList });

  const [expandedProject, setExpandedProject] = useState(null);
  const toggleExpand = (project) => {
    setExpandedProject(prev => (prev === project ? null : project));
  };
  return (
    <div className="project-access-modal">
      <div className="project-access-container">
        <div className="project-access-header">
          <span>{isEditMode ? "Edit User" : "Add User"}</span>
          <MdCancel className="project-access-close" onClick={onClose} />
        </div>

        <div className="project-access-body">

          {/* USER BASIC INFO */}
          <div className="user-fields-grid">

            <div className="form-group user-form-group">
              <label>Username <span style={{ color: "#dc3545" }}>*</span></label>
              <input
                className={`form-control ${errors.username ? "is-invalid" : ""}`}
                name="username"
                value={userState.username}
                onChange={handleChange}
                placeholder="Enter username"
                disabled={isEditMode}
              />
              {errors.username && <div className="field-error">{errors.username}</div>}
            </div>

            <div className="form-group user-form-group">
              <label>Email <span style={{ color: "#dc3545" }}>*</span></label>
              <input
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                name="email"
                value={userState.email}
                onChange={handleChange}
                placeholder="Enter Email"
                disabled={isEditMode}
              />
              {errors.email && <div className="field-error">{errors.email}</div>}
            </div>
            {!isEditMode && (
              <div className="form-group user-form-group">
                <input type="password" name="fake-pass" style={{ display: "none" }} />
                <label>Password <span style={{ color: "#dc3545" }}>*</span> </label>
                <div className="password-input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={userState.password || ""}
                    onChange={handleChange}
                    className={`custom-select ${errors.password ? "is-invalid" : ""}`}
                    placeholder="Enter Password"
                    name="password"
                    autoComplete="new-password"
                  />

                  <span
                    className="password-toggle-icons"
                    onClick={() => setShowPassword(prev => !prev)}
                  >
                    {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                  </span>
                </div>

                {errors.password && (
                  <div className="field-error">{errors.password}</div>
                )}
              </div>
            )}
            
            <div className="form-group user-form-group">
              <label>Access Level<span style={{ color: "#dc3545" }}>*</span></label>

              <select
                className={`form-control ${errors.accessLevel ? "is-invalid" : ""}`}
                name="accessLevel"
                value={userState.accessLevel}
                disabled={!isAdmin}
                onChange={handleChange}
                autoComplete="off"
              >
                {Object.entries(ACCESS_LEVEL).map(([value, cfg]) => (
                  <option key={value} value={value}>
                    {cfg.label}
                  </option>
                ))}
              </select>

              {errors.accessLevel && (
                <div className="field-error">{errors.accessLevel}</div>
              )}
            </div>

            {/* CALL ACCESS */}
            {userState.accessLevel === "2" && (
              <div
                className="form-group user-form-group"
                style={{
                  marginTop: isEditMode ? "28px" : "0px"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "25px"
                  }}
                >
                  <label style={{ display: "flex", alignItems: "center", gap: "8px", margin: 0 }}>
                    <input
                      type="checkbox"
                      checked={!!userState.callAccess}
                      onChange={(e) =>
                        setUserState(prev => ({
                          ...prev,
                          callAccess: e.target.checked
                        }))
                      }
                      disabled={!isAdmin}
                    />
                    Call Access
                  </label>
                </div>
              </div>
            )}
          </div>

          {/* PROJECT ACCESS */}
          <div className="project-access-section form-group user-form-group">
            <label>Project Access Level</label>

            {["winter-soldier", "summer-warrior"].map(project => (
              <div key={project} className="project-card">
                <div className="project-row">
                  <label className="project-label">
                    <input
                      type="checkbox"
                      checked={!!userState.projectAccess[project]?.enabled}
                      onChange={() => toggleIfAdmin(project)}
                      disabled={!isAdmin}
                    />
                    <span>{project.replace("-", " ").toUpperCase()}</span>
                  </label>

                  {userState.projectAccess[project]?.enabled &&
                    userState.accessLevel !== "1" &&
                    userState.accessLevel !== "Admin" && (
                      <div className="project-right">
                        {expandedProject === project && (
                          <div className="project-actions">
                            <button
                              type="button"
                              onClick={() => selectAllDatasets(project)}
                              disabled={!isAdmin}
                            >
                              Select All
                            </button>
                            <span>|</span>
                            <button
                              type="button"
                              onClick={() => deselectAllDatasets(project)}
                              disabled={!isAdmin}
                            >
                              Deselect All
                            </button>
                          </div>
                        )}

                        <span
                          className={`project-chevron ${expandedProject === project ? "open" : ""}`}
                          onClick={() => toggleExpand(project)}
                        >
                          {expandedProject === project ? <IoIosArrowUp /> : <IoIosArrowDown />}
                        </span>
                      </div>
                    )}

                </div>

                {userState.projectAccess[project]?.enabled &&
                  expandedProject === project &&
                  userState.accessLevel !== "1" &&
                  userState.accessLevel !== "Admin" && (
                    <div className="dataset-scroll">
                      <div className="dataset-grid">
                        {Array.isArray(datasets) && datasets.length > 0 ? (
                          datasets.map(ds => (
                            <label key={ds.id} className="dataset-box">
                              <input
                                type="checkbox"
                                checked={(userState.projectAccess[project]?.datasets || []).includes(ds.datasetID)}
                                onChange={() => toggleDataset(project, ds.datasetID)}
                                disabled={!isAdmin}
                              />
                              <span>{ds.datasetID}</span>
                            </label>
                          ))
                        ) : (
                          <span className="dataset-empty">No datasets available</span>
                        )}
                      </div>
                    </div>
                  )}
              </div>
            ))}
            <div className="project-card">
              <div className="project-row">
                <label className="project-label">
                  <input
                    type="checkbox"
                    checked={!!userState.projectAccess["poke-man"]?.enabled}
                    onChange={() => toggleIfAdmin("poke-man")}
                    disabled={!isAdmin}
                  />
                  <span>PRINT AND PRESORT</span>
                </label>
              </div>
            </div>
          </div>
          {errors.submit && <div className="field-error">{errors.submit}</div>}
          <div className="project-access-footer">
            <button
              className={`project-access-save-btn mt-4 ${isEditMode && !isAnythingChanged ? "disabled" : "enabled"
                }`}
              disabled={isEditMode && !isAnythingChanged}
              onClick={handleSave}
            >
              Save
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ProjectAccessModal;
